import { useState } from "react";

export default function useCreateUserGame(dispatch) {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    async function createUserGame(postData) {
        setLoading(true)
        setError(false)

		try {
            const res = await fetch ('/user_games', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(postData)
            })

			if (!res.ok) throw new Error(res.status)
			
            const data = await res.json()
			dispatch({type: "addUserGame", payload: data})

            return data

		} catch (err) {
			console.error('Fetch failed:', err)
			setError(err)
            return null
		} finally {
            //console.log('loading at end of create user game hook', loading)
            setLoading(false)
        }
    }
    
    return { createUserGame, error, loading }
}